<template>
	<div class="text-center">
		<span v-if="loading" class="img-thumbnail rounded bg-primary m-0 w-100"  style="width: 64px; height: 113px; display: block;">
			<span>
				<i class="fa fa-spinner fa-pulse fa-3x fa-fw text-white"></i>
			</span>
            <span class="sr-only">Loading...</span>
		</span>
		<div v-else>
			<img-view :src="image" :alt="alt" classimg="img-thumbnail img-fluid rounded" styleimg="height: 113px;" v-if="showRemove"></img-view>
			<p v-if="showRemove" class="m-0">
				<a href="#" @click.prevent="deleteFile">Remover</a>
			</p>
		</div>
	    <input :id="idForm" type="file" :name="nameForm" ref="logo" v-on:change="onFileChange" accept="image/*" class="d-none">
	</div>
</template>
<script>
	export default{
		props: {
            route: String,
            id: String,
            name: String,
            cliente: String,
            alt: String
        },

		data(){
			return {
				logo: '',
				image: '',
				loading: false,
				showRemove: false,
			}
		},

		mounted(){
			this.cleanField();
			if (this.route != '') {
				this.showRemove = true;
			}
		},

		methods: {
			loadFile(){
				this.$refs.logo.click();
			},

			onFileChange(e) {
		    	var file = e.target.files || e.dataTransfer.files;
		    	this.logo = this.$refs.logo.files[0];
		    	
		    	if (!this.logo)
		    		return;
		    	//this.createImage(file[0])
		    	this.uploadFile();
		    },

			createImage(file) {
		    	var image = new Image();
		    	var reader = new FileReader();
		    	var vm = this;

		    	reader.onload = (e) => {
		    		vm.image = e.target.result;
		     	};
		    	reader.readAsDataURL(file);
		    },

		    uploadFile(){
				var $module = this;
				let formData = new FormData();
	            formData.append('avatar', this.logo);
	            this.loading = true;

	            axios.post( '/api/clientes/'+this.cliente+'/avatar',
	               	formData,
	                {
	                	headers: {
	                    	'Content-Type': 'multipart/form-data'
	                	}
	              	}
	        	).then(function(response){
	        		$module.$toasted.show('La imagen ha sido actualizado.');
	        		$module.image = response.data;
	        		$module.showRemove = true;
	        	})
	        	.catch(function(error){
	        		console.log(error.response);
	        		$module.$toasted.show('Error al actualizar imagen.');
	          		$module.cleanField();
	        	}).then(() => {
	        		this.loading = false;
	        	});
			},

			deleteFile(){
				var $module = this;
				this.loading = true;

	            axios.delete('/api/clientes/'+this.cliente+'/avatar')
	            .then(function(response){
	        		$module.$toasted.show('La imagen ha sido eliminado.');
	        		$module.cleanField();
	        		$module.showRemove = false;
	        	})
	        	.catch(function(error){
	        		console.log(error.response);
	        		$module.$toasted.show('Error al eliminar imagen.');
	        	}).then(() => {
	        		this.loading = false;
	        	});
			},

			cleanField(){
				this.$refs.logo.value = '';
				this.image = this.routeImage || '';
			},
		},

		computed: {
		    routeImage: function () {
			    return this.route;
			},

			idForm: function(){
				return this.id || 'logo';
			},

			nameForm: function(){
				return this.name || 'logo';
			}
		},

		watch: {
			route: function(val){
				this.cleanField();
			}
		}
	}
</script>